export function registerTextDirectives(Alpine) {
  Alpine.directive("splitchars", (el) => {
    if (!window.gsap || !window.SplitText || !window.ScrollTrigger) return;
    if (el.dataset.splitcharsInit === "1") return;
    el.dataset.splitcharsInit = "1";
    let split, animation;
    function setup() {
      split && split.revert();
      animation && animation.revert();
      split = SplitText.create(el, { type: "chars,words,lines" });
      if (el.dataset.splitcharsPlayed === "1") {
        split.chars.forEach((charEl) => {
          charEl.style.transform = "translateX(0px)";
          charEl.style.opacity = "1";
        });
        return;
      }
      el.dataset.splitcharsPlayed = "1";
      animation = gsap.from(split.chars, {
        x: 150,
        opacity: 0,
        duration: 0.7,
        ease: "power4",
        stagger: 0.04,
        scrollTrigger: {
          trigger: el,
          start: "top 85%",
          once: true,
        },
      });
    }
    document.fonts.ready.then(setup);
    // window.addEventListener("resize", () => document.fonts.ready.then(setup));
  });

  Alpine.directive("splitlines", (el) => {
    if (!window.gsap || !window.SplitText || !window.ScrollTrigger) return;
    if (el.dataset.splitlinesInit === "1") return;
    el.dataset.splitlinesInit = "1";
    let split, animation;
    function setup() {
      split && split.revert();
      animation && animation.revert();
      split = SplitText.create(el, { type: "chars,words,lines" });
      if (el.dataset.splitlinesPlayed === "1") {
        split.lines.forEach((lineEl) => {
          lineEl.style.transform = "translateY(0px)";
          lineEl.style.opacity = "1";
        });
        return;
      }
      el.dataset.splitlinesPlayed = "1";
      animation = gsap.from(split.lines, {
        y: 98,
        opacity: 0,
        duration: 0.75,
        ease: "power4.out",
        stagger: 0.02,
        scrollTrigger: {
          trigger: el,
          start: "top 90%",
          once: true,
        },
      });
      el.__splitlinesSplit = split;
      el.__splitlinesAnim = animation;
    }
    document.fonts.ready.then(setup);
    el.__splitlinesSetup = setup;
    // window.addEventListener("resize", () => document.fonts.ready.then(setup));
  });

  Alpine.directive("watermarkrange", (el, { modifiers }) => {
    if (!window.gsap || !window.ScrollTrigger) return;
    if (el.classList.contains("watermark-range-init")) return;

    const isRight = modifiers.includes("right");
    const direction = isRight ? 1 : -1;
    const requestedDistance = Number(el.dataset.wmDistance || 180);
    const responsiveDistance = Math.round(window.innerWidth * 0.1);
    const distance = Math.min(
      requestedDistance,
      Math.max(72, responsiveDistance),
    );
    const trigger = el.closest("section") || el.parentElement || el;
    const start = el.dataset.wmStart || "top 90%";
    const end = el.dataset.wmEnd || "top 48%";

    el.classList.add("watermark-range-init");
    gsap.set(el, { x: direction * distance, willChange: "transform" });
    gsap.to(el, {
      x: 0,
      ease: "none",
      scrollTrigger: {
        trigger,
        start,
        end,
        scrub: true,
        invalidateOnRefresh: true,
      },
    });
  });
}
